import React, { forwardRef } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import CarrierUserAutosuggest, { ICarrierUserAutosuggestProps } from '../../CarrierUserAutosuggest'

type IBaseControllerProps = ControllerProps<React.ComponentType<ICarrierUserAutosuggestProps>>

export interface IControlledCarrierUserAutosuggestProps
  extends Pick<
    IBaseControllerProps,
    | 'control'
    | 'name'
    | 'defaultValue'
    | 'AutocompleteProps'
    | 'carrierId'
    | 'onInputChange'
    | 'onUserChange'
    | 'user'
    | 'defaultInputValue'
    | 'userTypes'
  > {}

const ControlledCarrierUserAutosuggest = forwardRef<
  HTMLInputElement,
  IControlledCarrierUserAutosuggestProps
>(
  ({
    AutocompleteProps,
    carrierId,
    control,
    defaultInputValue,
    defaultValue = '',
    name,
    onInputChange,
    onUserChange,
    user,
    userTypes,
  }) => {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ name, onBlur, onChange, ref, value }) => {
          return (
            <CarrierUserAutosuggest
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              name={name}
              ref={ref}
              carrierId={carrierId}
              userTypes={userTypes}
              user={user}
              defaultInputValue={defaultInputValue}
              onInputChange={onInputChange}
              onUserChange={onUserChange}
              AutocompleteProps={AutocompleteProps}
            />
          )
        }}
      />
    )
  }
)

export default ControlledCarrierUserAutosuggest
